import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { RouteParams, useNamedRoutes } from "./NamedRoutes";


export function useGoBackOrFallback(fallbackRoute = "home", routeParams?: RouteParams)
{
    const history = useHistory();
    const { generate } = useNamedRoutes();

    return useCallback(() =>
    {
        if (window.history.length > 1) {
            history.goBack();
        } else {
            history.push(generate(fallbackRoute, routeParams));
        }
    }, [history, generate, fallbackRoute]);
}
